import { render, staticRenderFns } from "./paymentDetailNex.vue?vue&type=template&id=9833bd48&scoped=true&"
import script from "./paymentDetailNex.vue?vue&type=script&lang=ts&"
export * from "./paymentDetailNex.vue?vue&type=script&lang=ts&"
import style0 from "./paymentDetailNex.vue?vue&type=style&index=0&id=9833bd48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9833bd48",
  null
  
)

export default component.exports